import MojitoPresentation from 'mojito/presentation';
import { range } from 'mojito/utils';

const { FlexPane, SkeletonPart } = MojitoPresentation.Components;

const EventVisualisationSkeleton = props => {
    const {
        mojitoTools: { config },
    } = props;

    return (
        <FlexPane class="ta-EventVisualisationSkeleton" config={config.container}>
            <Scoreboard config={config} />
            <MarketGroupCategoriesMenu config={config} />
        </FlexPane>
    );
};

const Scoreboard = ({ config }) => (
    <FlexPane config={config.scoreboardContainer}>
        <SkeletonPart config={config.scoreboardSkeletonPart} />
    </FlexPane>
);

const MarketGroupCategoriesMenu = ({ config }) => (
    <FlexPane config={config.marketGroupCategoriesMenuContainer}>
        {range(config.numberOfMarketGroupCategoriesMenuItem).map(i => (
            <SkeletonPart key={i} config={config.marketGroupCategoriesMenuItem} />
        ))}
    </FlexPane>
);

export default EventVisualisationSkeleton;
